<div class="location-list">
  <div class="location-search">
    <div>
      <div class="form-group mb-1">
        <label class="fw-bold form-label">{{localize(langSection.LocationList, langText.SearchLocations)}}</label>
        <div class="input-group-text">
          <input class="form-control rounded-0 border-dark" [(ngModel)]="locationQuery"
            (input)="setLocationListQuery($event.target.value)" />
          <button aria-label="Search Locations" class="btn border-dark rounded-0 bg-green" type="button"
            (click)="clearSearch()"><span class="{{iconClass}}"></span></button>
        </div>
      </div>
      <div class="fst-italic mb-3">{{locationsDisplayed}}</div>
    </div>
  </div>
  <div class="form-group">
    <label for="locationSortBy" class="form-label"><strong>{{localize(langSection.HomePage, langText.SortBy)}}</strong></label>
    <div class="sort-locations">
      <ups-select class="mb-3" (change)="onSortChange($event.target.value)" id="locationSortBy" [list]="sortOptions" [value]="sortLocationValue"></ups-select>
      <button aria-label="Ascending or Descending" class="up-and-down-sort btn" type="button" (click)="onSortClick()"></button>
    </div>
</div>

  <virtual-scroller (scroll)="locationListScroll($event)" #scroll class="location-items" [items]="filteredLocations" [checkResizeInterval]="175"
    [modifyOverflowStyleOfParentScroll]="false">
    @for (location of scroll.viewPortItems; track location; let i = $index) {
<location
      [ngClass]="selectedLocations.length > 0 && isLocationSelected(location.slicName) ? 'selected' : ''" [location]="location"
      (click)="setSelection(location)">
    </location>
}
  </virtual-scroller>

  @if (showLoadMoreButton && !locationQuery) {
<button class="load-more-btn"
    (click)="loadMore()">{{localize(langSection.LocationList, langText.LoadMore1)}} {{unloadedLocationCount}}
    {{localize(langSection.LocationList, langText.LoadMore2)}}</button>
}
</div>